import { createTheme, responsiveFontSizes } from '@material-ui/core/styles';

// Brand colors, shared by the theme and a few hand-styled spots.
export const brand = {
  ink: '#1C1B19',
  inkLight: '#2E2C29',
  accent: '#A4472B',
  accentDark: '#873A22',
  accentSoft: '#F1E4DC',
  paper: '#F5F2EC',
  stone: '#E9E4DA',
  muted: '#6B665E',
  line: '#D9D3C7',
};

export const serif = '"Fraunces", Georgia, "Times New Roman", serif';
const sans = '"Work Sans", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif';

let theme = createTheme({
  palette: {
    primary: {
      main: brand.ink,
      light: brand.inkLight,
      contrastText: '#FFFFFF',
    },
    secondary: {
      main: brand.accent,
      dark: brand.accentDark,
      contrastText: '#FFFFFF',
    },
    background: {
      default: brand.paper,
      paper: '#FFFFFF',
    },
    text: {
      primary: brand.ink,
      secondary: brand.muted,
    },
    divider: brand.line,
  },
  shape: {
    borderRadius: 2,
  },
  typography: {
    fontFamily: sans,
    h1: { fontFamily: serif, fontWeight: 400, fontSize: '4.25rem', lineHeight: 1.02, letterSpacing: '-0.02em' },
    h2: { fontFamily: serif, fontWeight: 400, fontSize: '3rem', lineHeight: 1.08, letterSpacing: '-0.015em' },
    h3: { fontFamily: serif, fontWeight: 400, fontSize: '2.1rem', lineHeight: 1.15, letterSpacing: '-0.01em' },
    h4: { fontFamily: serif, fontWeight: 400, fontSize: '1.6rem', lineHeight: 1.2 },
    h5: { fontFamily: serif, fontWeight: 500, fontSize: '1.3rem', lineHeight: 1.3 },
    h6: { fontFamily: sans, fontWeight: 600, fontSize: '1rem', lineHeight: 1.4 },
    subtitle1: { fontSize: '1.0625rem', lineHeight: 1.65 },
    body1: { fontSize: '1rem', lineHeight: 1.65 },
    body2: { fontSize: '0.9375rem', lineHeight: 1.6 },
    overline: { fontWeight: 600, letterSpacing: '0.16em', fontSize: '0.75rem', lineHeight: 1.5 },
    button: { textTransform: 'none', fontWeight: 600, letterSpacing: '0.01em' },
  },
  props: {
    MuiButton: { disableElevation: true },
    MuiPaper: { elevation: 0 },
  },
  overrides: {
    MuiButton: {
      root: { borderRadius: 0, padding: '11px 22px' },
      sizeLarge: { padding: '15px 28px', fontSize: '1rem' },
      containedPrimary: {
        '&:hover': { backgroundColor: brand.accent },
      },
      outlined: { borderColor: brand.ink },
    },
    MuiInput: {
      underline: {
        '&:before': { borderBottomColor: brand.line },
        '&:hover:not($disabled):before': { borderBottomColor: brand.muted },
        '&:after': { borderBottomColor: brand.accent },
      },
    },
    MuiInputLabel: {
      root: { '&$focused': { color: brand.accent } },
    },
    MuiOutlinedInput: {
      root: {
        backgroundColor: '#FFFFFF',
        '&$focused $notchedOutline': { borderColor: brand.accent },
      },
      notchedOutline: { borderColor: brand.line },
    },
    MuiPaper: {
      rounded: { borderRadius: 0 },
      outlined: { borderColor: brand.line },
    },
    MuiTab: {
      root: { textTransform: 'none', fontWeight: 600, fontSize: '0.95rem', minWidth: 0 },
    },
    MuiChip: {
      root: { borderRadius: 2 },
    },
  },
});

theme = responsiveFontSizes(theme, { factor: 2.2 });

export default theme;
